import {computed} from "vue";
import { useSubAppStore } from '@/store/modules/subApp';
import {getUrlParams, StorageUtils} from 'xmgoing-utils';
import {useAppStore} from "@/store/modules/app";
import GoingUtils from "@/utils/goingUtils";

export function useSubAppInfos(){
  //子应用信息
  const subAppStore = useSubAppStore();
  const appStore = useAppStore();
  // const subAppTitle = ref(StorageUtils.getSessionItem("appName"));
  //
  //
  // if(unref(subAppTitle)==null||unref(subAppTitle)===""){
  //   subAppTitle.value=appStore.appObj.name;
  // }

  const subAppTitle=computed(()=>{
    if(getUrlParams("appName",true)){
      StorageUtils.addSessionItem("appName",getUrlParams("appName",true))
      return getUrlParams("appName",true);
    }
    if(StorageUtils.getSessionItem("appName")){
      return StorageUtils.getSessionItem("appName");
    }else{
      return  appStore.appObj.name;
    }
  })
  //打开和关闭子应用菜单
  const openCloseMenu=()=>{
    subAppStore.setMenuFlag(!subAppStore.menuFlag);
  }
  //获取菜单标志
  const getMenuFlag = computed(() => subAppStore.menuFlag);

  return {
    getMenuFlag,
    openCloseMenu,
    subAppTitle,
  }
}
